import { styled } from '@mui/material/styles';

var PREFIX = "ActionsBarLayout";
var classes = {
    actions: "".concat(PREFIX, "-actions"),
    facets: "".concat(PREFIX, "-facets"),
    count: "".concat(PREFIX, "-count"),
    sort: "".concat(PREFIX, "-sort"),
    mode: "".concat(PREFIX, "-mode")
};
var StyledActionsBar = styled("div")(function (_a) {
    var _b, _c, _d, _e, _f;
    var theme = _a.theme;
    return (_b = {
            backgroundColor: theme.palette.background.paper,
            display: "grid",
            alignItems: "center",
            gridTemplateAreas: "\"facets count actions sort mode\"",
            gridTemplateColumns: "max-content max-content 1fr max-content max-content",
            gap: theme.spacing(1),
            borderBottom: "1px solid ".concat(theme.palette.grey[300])
        },
        _b[theme.breakpoints.down("md")] = {
            gridTemplateAreas: "\"actions actions actions actions\" \"facets count sort mode\"",
            gridTemplateColumns: "max-content max-content 1fr"
        },
        _b[theme.breakpoints.down("sm")] = {
            gridTemplateAreas: "\"actions actions actions\" \"sort sort sort\" \"facets count mode\"",
            gridTemplateColumns: "max-content max-content 1fr",
            gap: 0
        },
        _b["& .".concat(classes.actions)] = (_c = {
                gridArea: "actions",
                // Extra space for actions
                padding: theme.spacing(0, 1)
            },
            _c[theme.breakpoints.down("md")] = {
                padding: theme.spacing(1),
                display: "flex",
                justifyContent: "flex-start"
            },
            _c[theme.breakpoints.down("sm")] = {
                minHeight: "inherit",
                padding: theme.spacing(1),
                display: "flex",
                justifyContent: "space-between"
            },
            _c),
        _b["& .".concat(classes.facets)] = {
            gridArea: "facets"
        },
        _b["& .".concat(classes.count)] = {
            gridArea: "count",
            "& .ElementCount-count": (_d = {
                    fontSize: ".8rem"
                },
                _d[theme.breakpoints.down("sm")] = {
                    fontSize: ".7rem"
                },
                _d)
        },
        _b["& .".concat(classes.sort)] = (_e = {
                gridArea: "sort",
                justifySelf: "end",
                "& .MuiBox-root": {
                    flexDirection: "row-reverse"
                },
                paddingTop: "6px"
            },
            _e[theme.breakpoints.down("sm")] = {
                marginRight: theme.spacing(0.25)
            },
            _e[theme.breakpoints.down("md")] = {
                marginRight: theme.spacing(1)
            },
            _e),
        _b["& .".concat(classes.mode)] = (_f = {
                gridArea: "mode",
                paddingTop: "3px",
                marginRight: theme.spacing(1),
                "& .MuiButtonBase-root": {
                    borderRadius: theme.spacing(0.5)
                }
            },
            _f[theme.breakpoints.down("md")] = {
                justifySelf: "end",
                "& .MuiButton-root": {
                    fontSize: "1rem",
                    padding: theme.spacing(0.25, 0.5),
                    minWidth: "48px"
                }
            },
            _f),
        _b);
});

export { classes, StyledActionsBar as default };
//# sourceMappingURL=index.styled.js.map
